import { useState } from 'react';
import { CONTACT_EMAIL } from '../../constants/content';
import { mailtoLink } from '../../constants/navigation';
import { CTAButton } from './CTAButton';

export function InquiryForm({
  productName = '',
  subject = 'Ameowzing 购买咨询',
  showProductField = true,
}) {
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.target;
    const data = new FormData(form);
    const body = [
      `姓名：${data.get('name')}`,
      `联系邮箱：${data.get('email')}`,
      `联系电话：${data.get('phone') || '未填写'}`,
      showProductField ? `意向产品：${data.get('product') || productName || '未指定'}` : null,
      `预计数量：${data.get('quantity') || '未填写'}`,
      `用途说明：${data.get('purpose') || '未填写'}`,
      '',
      '留言：',
      data.get('message') || '无',
    ]
      .filter(Boolean)
      .join('\n');

    window.location.href = mailtoLink(subject, body);
    setSubmitted(true);
  };

  if (submitted) {
    return (
      <div className="bg-green-500/10 border border-green-500/30 rounded-2xl p-8 text-center">
        <i className="fa fa-check-circle text-green-400 text-4xl mb-4" />
        <h3 className="text-xl font-semibold mb-2">正在打开邮件客户端</h3>
        <p className="text-purple-200 text-sm mb-4">
          请确认邮件内容后发送，我们将在 1-2 个工作日内回复。
        </p>
        <p className="text-purple-400 text-xs">
          若未自动打开，请手动发送至 {CONTACT_EMAIL}
        </p>
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-5">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
        <FormField label="姓名" name="name" required placeholder="您的姓名" />
        <FormField label="联系邮箱" name="email" type="email" required placeholder="example@email.com" />
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
        <FormField label="联系电话" name="phone" placeholder="选填" />
        <FormField label="预计数量" name="quantity" placeholder="如：10 件 / 100 件" />
      </div>
      {showProductField && (
        <FormField
          label="意向产品"
          name="product"
          defaultValue={productName}
          placeholder="如：榴莲毛绒公仔"
        />
      )}
      <FormField label="用途说明" name="purpose" placeholder="零售 / 企业礼品 / 活动赠品等" />
      <div>
        <label htmlFor="message" className="block text-sm text-purple-300 mb-2">
          留言补充
        </label>
        <textarea
          id="message"
          name="message"
          rows={4}
          placeholder="请描述您的具体需求、定制要求或希望收到回复的时间..."
          className="w-full bg-darker/50 border border-purple-500/30 rounded-xl px-4 py-3 text-light placeholder-purple-500 focus:outline-none focus:border-secondary transition-colors resize-none"
        />
      </div>
      <CTAButton type="submit" variant="primary" size="lg" icon="fa-paper-plane" className="w-full sm:w-auto">
        提交购买咨询
      </CTAButton>
      <p className="text-purple-500 text-xs">
        提交后将打开邮件客户端，您确认发送后我们即可收到咨询信息。
      </p>
    </form>
  );
}

function FormField({ label, name, type = 'text', required, placeholder, defaultValue }) {
  return (
    <div>
      <label htmlFor={name} className="block text-sm text-purple-300 mb-2">
        {label}
        {required && <span className="text-pink-400 ml-1">*</span>}
      </label>
      <input
        id={name}
        name={name}
        type={type}
        required={required}
        placeholder={placeholder}
        defaultValue={defaultValue}
        className="w-full bg-darker/50 border border-purple-500/30 rounded-xl px-4 py-3 text-light placeholder-purple-500 focus:outline-none focus:border-secondary transition-colors"
      />
    </div>
  );
}
